// importing styles
import "./work-section-styles.scss";

// importing icons
import { MdOutlineWorkOutline } from "react-icons/md";
import { FiArrowUpRight } from "react-icons/fi";

// importing components
import ProjectsComponent from "../../components/projects-component/projects-component";
import SectionSubHeadingComponent from "../../components/section-sub-heading-component/section-sub-heading-component";
import SectionHeadingComponent from "../../components/section-heading-component/section-heading-component";
import ButtonComponent from "../../components/button-component/button-component";

const WorkSection = () => {
	return (
		<section id="work-section" className="work-section">
			<div className="work-section-content-wrapper">
				{/* Section sub heading */}
				<SectionSubHeadingComponent
					icon={<MdOutlineWorkOutline />}
					text="Projects"
				/>

				{/* Section heading */}
				<SectionHeadingComponent text="Bridging the Gap Between Imagination and Execution" />

				{/* Component containing filter categories and project cards */}
				<ProjectsComponent />

				{/* full-width button */}
				<ButtonComponent
					text="View All Projects"
					icon={<FiArrowUpRight />}
					type="large"
					btnLink="https://github.com/moazamdev"
					newTab="true"
				/>
			</div>
		</section>
	);
};

export default WorkSection;
